// „Nie pamiętasz hasła?" — krok pierwszy z dwóch (artboardy 05a, 05b).
//
// Backend odpowiada IDENTYCZNIE niezależnie od tego, czy konto istnieje
// (anty-enumeracja, §9), więc ten ekran NIGDY nie może powiedzieć „nie ma takiego
// konta" — także przypadkiem, np. innym komunikatem przy 404. Stan po wysłaniu jest
// jedynym wynikiem i mówi „jeśli takie konto istnieje", co jest prawdą.
//
// Dwa zdania bezpieczeństwa zostają, bo są faktami, a nie ozdobą: link działa 30 minut
// i tylko raz (decyzja 9 sesji 37).

import { useState } from 'react'
import { Link } from 'react-router'
import AuthShell from '../components/AuthShell'
import Icon from '../components/Icon'
import { Button, Field } from '../ds'
import { api } from '../lib/api'
import { useT } from '../lib/i18n'

export default function Forgot() {
  const t = useT()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api('/auth/forgot', { method: 'POST', body: JSON.stringify({ email }) })
      setSent(true)
    } catch {
      // Jedyna prawdziwa awaria to „nie dało się dojść do serwera": odrzucony adres
      // nie jest czymś, co ten endpoint zgłasza, i nie wolno nam tego wymyślać.
      setError(t('auth.forgot.networkError'))
    } finally {
      setBusy(false)
    }
  }

  if (sent) {
    return (
      <AuthShell>
        <span className="mp-auth-glyph" aria-hidden="true"><Icon name="Mail" size={48} /></span>
        <h1>{t('auth.forgot.doneHeading')}</h1>
        <p className="mp-auth-body">
          {t('auth.forgot.doneBefore')}<b>{email}</b>{t('auth.forgot.doneAfter')}
        </p>
        <p className="mp-auth-body">{t('auth.forgot.linkLife')}</p>
        <p className="mp-auth-foot">
          <Link to="/login" className="mn-lnk">{t('auth.forgot.backToLogin')}</Link>
        </p>
      </AuthShell>
    )
  }

  return (
    <AuthShell>
      <h1>{t('auth.forgot.heading')}</h1>

      {error && <p className="mp-err" role="alert">{error}</p>}

      <form onSubmit={onSubmit}>
        <Field
          id="email"
          type="email"
          label={t('auth.forgot.emailLabel')}
          placeholder={t('auth.login.emailPlaceholder')}
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Button type="submit" variant="primary" busy={busy} disabled={!email.trim()}>
          {t('auth.forgot.submit')}
        </Button>
      </form>

      <p className="mp-auth-foot is-centered">
        <Link to="/login" className="mn-lnk">{t('auth.forgot.backToLogin')}</Link>
      </p>
    </AuthShell>
  )
}
